import { demoShifts } from '@/mocks/demoData';
import type { Shift } from '@/mocks/data';
import { addActivityLog } from '@/utils/activityLogStore';

let shifts: Shift[] = [...demoShifts];

export function getShifts(): Shift[] {
  return shifts;
}

export function getActiveShift(): Shift | undefined {
  return shifts.find((s) => s.status === 'active');
}

export function getShiftById(id: string): Shift | undefined {
  return shifts.find((s) => s.id === id);
}

export function addShiftPayment(amount: number, method: 'cash' | 'card' | 'upi'): void {
  const active = shifts.find((s) => s.status === 'active');
  if (!active) return;
  const key = `${method}_collections` as keyof Shift;
  shifts = shifts.map((s) => {
    if (s.id === active.id) {
      const current = (s[key] as number) || 0;
      const newCollections = s.collections + amount;
      return { ...s, [key]: current + amount, collections: newCollections };
    }
    return s;
  });
}

export function addShiftCollectionFromCanteen(amount: number, method: string): void {
  const normalized = method === 'room_charge' ? null : method as 'cash' | 'card' | 'upi';
  if (!normalized) return;
  const active = shifts.find((s) => s.status === 'active');
  if (!active) return;
  const methodKey = `${normalized}_collections` as keyof Shift;
  const canteenMethodKey = `canteen_${normalized}` as keyof Shift;
  shifts = shifts.map((s) => {
    if (s.id === active.id) {
      const currentMethod = (s[methodKey] as number) || 0;
      const currentCanteenMethod = (s[canteenMethodKey] as number) || 0;
      const currentCanteenTotal = (s.canteen_collections as number) || 0;
      return {
        ...s,
        [methodKey]: currentMethod + amount,
        collections: s.collections + amount,
        [canteenMethodKey]: currentCanteenMethod + amount,
        canteen_collections: currentCanteenTotal + amount,
      };
    }
    return s;
  });
}

export function addShift(newShift: Shift): void {
  shifts = shifts.map((s) => (s.status === 'active' ? { ...s, status: 'closed' as const } : s));
  shifts = [...shifts, newShift];
}

export function endShift(shiftId: string): void {
  shifts = shifts.map((s) =>
    s.id === shiftId
      ? { ...s, status: 'closed' as const, closing_balance: s.opening_balance + s.collections }
      : s
  );
}